module.exports = __webpack_public_path__ + "img/3_2.2ecefa0f.png";